module.exports = __webpack_public_path__ + "img/TECATE00_REGISTER.142da2f0.jpg";